import * as THREE from 'three';

// Loads the woofer tools/build-woofer.mjs prepared for visualizers/woofer.js:
// the picture with the LEDs off and its glints removed (base), the light the
// LED ring adds (light), the soft masks (surround, cone, cap), the fields
// (the surround's radial coordinate s, the cone's c, the glints) and the
// measured geometry (ellipses, tilt, projected axis). ONCE, at startup. The
// preload is a WIRING POINT every entry point must call (main, main-radio,
// play-boot, the capture harness); it resolves false when anything is
// missing so the entry point withdraws Woofer from the rotation.
const MANIFEST_URL = 'textures/woofer.json';

let _assets = null;
let _promise = null;

function loadTexture(url, configure) {
  return new Promise(function (resolve, reject) {
    new THREE.TextureLoader().load(url, function (t) { configure(t); t.needsUpdate = true; resolve(t); }, undefined, function () {
      reject(new Error(url + ' failed to load'));
    });
  });
}
function photo(t) {
  t.colorSpace = THREE.SRGBColorSpace;
  t.generateMipmaps = false;
  t.minFilter = THREE.LinearFilter;
  t.magFilter = THREE.LinearFilter;
  t.wrapS = t.wrapT = THREE.ClampToEdgeWrapping;
}
// masks and fields are READ AT WARPED positions: linear filtering, never
// nearest (a nearest read of a displaced mask steps by whole pixels)
function data(t) {
  t.colorSpace = THREE.NoColorSpace;
  t.generateMipmaps = false;
  t.minFilter = THREE.LinearFilter;
  t.magFilter = THREE.LinearFilter;
  t.wrapS = t.wrapT = THREE.ClampToEdgeWrapping;
}

export function preloadWoofer() {
  if (_promise) return _promise.then(function (a) { return !!a; });
  _promise = fetch(MANIFEST_URL)
    .then(function (r) {
      if (!r.ok) throw new Error('woofer.json HTTP ' + r.status);
      return r.json();
    })
    .then(function (manifest) {
      return Promise.all([
        loadTexture('textures/' + manifest.base, photo),
        loadTexture('textures/' + manifest.light, photo),
        loadTexture('textures/' + manifest.masks, data),
        loadTexture('textures/' + manifest.fields, data),
        fetch('textures/' + manifest.data).then(function (r) {
          if (!r.ok) throw new Error(manifest.data + ' HTTP ' + r.status);
          return r.json();
        })
      ]).then(function (parts) {
        _assets = { manifest: manifest, base: parts[0], light: parts[1], masks: parts[2], fields: parts[3], data: parts[4] };
        return _assets;
      });
    })
    .catch(function (err) {
      console.error('[party-mode] woofer assets unavailable, Woofer is withdrawn', err);
      _assets = null;
      return null;
    });
  return _promise.then(function (a) { return !!a; });
}

export function getWoofer() {
  return _assets;
}
